var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5358_3338",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5358_3338)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.0026 7.83333C8.32483 7.83333 8.59994 7.71956 8.82794 7.492C9.05549 7.264 9.16927 6.98889 9.16927 6.66667C9.16927 6.34444 9.05549 6.06933 8.82794 5.84133C8.59994 5.61378 8.32483 5.5 8.0026 5.5C7.68038 5.5 7.40527 5.61378 7.17727 5.84133C6.94972 6.06933 6.83594 6.34444 6.83594 6.66667C6.83594 6.98889 6.94972 7.264 7.17727 7.492C7.40527 7.71956 7.68038 7.83333 8.0026 7.83333ZM8.0026 14.5333C6.26927 13.0222 4.97483 11.6222 4.11927 10.3333C3.26372 9.04444 2.83594 7.86667 2.83594 6.8C2.83594 5.18889 3.35549 3.90267 4.3946 2.94133C5.43327 1.98044 6.63594 1.5 8.0026 1.5C9.36927 1.5 10.5722 1.98044 11.6113 2.94133C12.6499 3.90267 13.1693 5.18889 13.1693 6.8C13.1693 7.86667 12.7415 9.04444 11.8859 10.3333C11.0304 11.6222 9.73594 13.0222 8.0026 14.5333Z",
    fill: "#7C7FA7",
    fillOpacity: 0.7
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.c9336c8db0ac8c7313a69ba6a0bb9db4.svg";
export { ForwardRef as ReactComponent };